export const CLIENT_LANDING_PATH = '/inspectionclientreport';

export const isClient = (userType) => userType === 'client';

export const getLandingPath = (userType) =>
  isClient(userType) ? CLIENT_LANDING_PATH : '/home';

const normalizeUrl = (url) => (url || '').replace(/\/+$/, '');

export const getComparablePath = (pathname) =>
  pathname.startsWith('/modifyInspection/')
    ? '/createinspection/'
    : `${pathname}/`;

export const menuHasPath = (menu, pathname) => {
  const currentUrl = getComparablePath(pathname);

  return Object.values(menu || {}).some((items) =>
    (items || []).some(
      (item) =>
        item?.url && currentUrl.startsWith(`${normalizeUrl(item.url)}/`)
    )
  );
};

export const shouldRedirectToLogin = (menu, pathname, userType) => {
  const currentUrl = getComparablePath(pathname);

  if (currentUrl === '/home/') return false;
  if (isClient(userType) && currentUrl === `${CLIENT_LANDING_PATH}/`) {
    return false;
  }

  return !menuHasPath(menu, pathname);
};
